export const HeroBackground = () => (
<div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1768122735840-8f0a04cbfef6" 
            alt="Marabout Africain Sorcier Vaudou Guadeloupe - Rituels Spirituels Puissants" 
            className="w-full h-full object-cover opacity-25"
            loading="eager"
            fetchPriority="high"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/85 to-black"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/10 to-transparent"></div>
        </div>
);
